export default String.raw`
.history-popup {
  min-width: 500px;
  max-width: 768px;
  max-height: 588px;

  .dialog {
      &__header {
          @include h2-headline;
      }

      &__content {
          padding: 8px 32px 32px 32px;
          gap: 24px;
      }
  }

  &__date {
      @include body-1-medium;
  }

  &__no-purchase {
      @include body-1-regular;
  }

  &__table {
      display: block;
      border-collapse: separate;
      border-spacing: 0;
      width: 100%;
      overflow: auto;

      .table {
          &__header {
              .table__cell {
                  position: sticky;
                  background: #F8F9FA;
                  border-bottom: 1px solid #D5D5D5;
                  z-index: 1;
                  top: 0;
                  @include body-1-medium;
              }
          }

          &__body {
            @include body-1-regular;
          }

          &__cell {
              border-bottom: 1px solid #D5D5D5;
              position: relative;
              padding: 12px 16px;

              &:nth-child(-n+2) { 
                  text-align: left;
              }

              &:nth-last-child(-n+2) {
                  text-align: right;
              }

              &:not(:last-child) {
                  &::after {
                      content: ''; 
                      position: absolute; 
                      right: 0; 
                      width: 1px; 
                      height: 24px;
                      background-color: #D5D5D5;
                      top: 50%;
                      transform: translateY(-50%);
                  }
              }
          }
      }
  }
}

//State:
.history-popup-js:has(.history-popup-table-content-js:not(:empty)) .no-purchase-history-js {
    display: none;
}

.history-popup-js:has(.history-popup-table-content-js:empty) .history-popup-table-js {
    display: none;
}



`